<template>
	<div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
			<el-col :span="18" class="app-main-header-btns">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd"
					v-hasPermi="['system:permission:add']">新增
				</el-button>
			</el-col>
		</el-row>

		<el-row class="mg-b5">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<el-form :inline="true">
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
								prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-select size="mini" clearable v-model="quertInfo.objMap.status" placeholder="选择状态">
								<el-option label="启用" value="0"></el-option>
								<el-option label="禁用" value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" icon="el-icon-search" @click="onSearch"
								v-hasPermi="['system:permission:query']">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
				<el-table :data="tableData" row-key="id"
					:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column prop="name" label="菜单名称" width="200"></el-table-column>
					<el-table-column prop="orderNum" label="排序" width="100"></el-table-column>
					<el-table-column prop="type" label="类型" width="100" :formatter="formatType">
					</el-table-column>
					<el-table-column prop="icon" label="图标" width="100">
						<template slot-scope="scope">
							<i :class="scope.row.icon"></i>
						</template>
					</el-table-column>
					<el-table-column prop="description" label="菜单描述"></el-table-column>
					<el-table-column prop="component" label="组件路径" width="240"></el-table-column>
					<el-table-column prop="perms" label="权限标识"></el-table-column>
					<el-table-column prop="status" label="状态" width="100" :formatter="formatStatus"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="150">
						<template slot-scope="scope">
							<el-button type="text" icon="el-icon-edit" size="mini" @click="handleEdit(scope.row)"
								v-hasPermi="['system:permission:edit']">修改
							</el-button>
							<el-button type="text" icon="el-icon-delete" size="mini" @click="handleDel(scope.row.id)"
								v-hasPermi="['system:permission:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
		</el-row>
		<el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
			<el-form label-width="80px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="24">
						<el-form-item label="上级菜单">
							<treeselect v-model="form.parentId" :show-count="true" :options="optionMenus"
								:normalizer="normalizer" placeholder="选择上级菜单" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="菜单类型" prop="type">
							<el-radio-group v-model="form.type">
								<el-radio :label="0">目录</el-radio>
								<el-radio :label="1">菜单</el-radio>
								<el-radio :label="2">按钮</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="form.type!=2">
						<el-form-item label="菜单图标">
							<e-icon-picker v-model="form.icon" :options="optionIcons" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="菜单名称" prop="name">
							<el-input v-model="form.name" placeholder="请输入菜单名称" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="菜单排序" prop="orderNum">
							<el-input-number v-model="form.orderNum" controls-position="right" :min="1" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="菜单描述" prop="description">
							<el-input v-model="form.description" placeholder="请输入菜单描述" />
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.type!=2">
						<el-form-item label="路由地址" prop="url">
							<el-input v-model="form.url" placeholder="如: system" />
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.type!=0 && form.type!=2">
						<el-form-item label="组件路径" prop="component">
							<el-input v-model="form.component" placeholder="请输入组件路径" />
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.type!=0 && form.type!=1">
						<el-form-item label="权限标识" prop="perms">
							<el-input v-model="form.perms" placeholder="请输入权限标识" />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="状态" prop="status">
							<el-radio-group v-model="form.status">
								<el-radio :label="0">启用</el-radio>
								<el-radio :label="1">停用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		permissionList,
		addPermission,
		editPermission,
		delPermission
	} from '@/api/system/menu.js'
	import Treeselect from '@riophae/vue-treeselect'
	import '@riophae/vue-treeselect/dist/vue-treeselect.css'
	import {
		EIconPicker
	} from 'e-icon-picker';
	import 'e-icon-picker/lib/index.css'; //基础样式
	export default {
		name: "Menu",
		components: {
			Treeselect,
			EIconPicker
		},
		computed: {},
		data() {
			return {
				title: "",
				tableData: [],
				form: {},
				openDialog: false,
				optionIcons: {
					FontAwesome: false, //不使用 FontAwesome图标
					ElementUI: true,
					addIconList: [],
					removeIconList: []
				},
				optionMenus: [],
				quertInfo: {
					objMap: {
						search: ''
					},
				},
				rules: {
					name: [{
						required: true,
						message: '请输入菜单名称',
						trigger: 'blur'
					}],
					url: [{
						required: true,
						message: '请输入路由地址',
						trigger: 'blur'
					}],
					component: [{
						required: true,
						message: '请输入组件路径',
						trigger: 'blur'
					}],
					perms: [{
						required: true,
						message: '请输入权限标识',
						trigger: 'blur'
					}],
					parentId: [{
						required: true,
						message: '请选择父级',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请输入类型 0:目录1:菜单2:按钮',
						trigger: 'blur'
					}],
				}
			};
		},
		created() {
			this.getList();
		},
		methods: {
			async getList() {
				let _this = this;
				const {
					data: res
				} = await permissionList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
				} else {
					_this.$fail(res.msg);
				}
			},
			onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
			// 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					name: undefined,
					description: undefined,
					url: undefined,
					component: undefined,
					perms: undefined,
					parentId: undefined,
					type: 0,
					orderNum: 1,
					icon: '',
					status: 0,
				};
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
			},
			submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
						if (_this.form.id != undefined) {
							editPermission(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
							addPermission(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
									_this.getList();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
			/**
			 * 转换菜单数据结构
			 * vue-treeselect中，即使您为children属性分配一个空数组，依然会显示有分支，这时就可以使用normalizer去掉children属性：
			 */
			normalizer(node) {
				//删除 数据的子集
				if (node.children && !node.children.length) {
					delete node.children;
				}
				return {
					id: node.id,
					//将name转换成必填的label键
					label: node.name,
					children: node.children
				};
			},
			/** 查询菜单下拉树结构 */
			getTreeselect() {
				let _this = this;
				_this.optionMenus = [];
				const menu = {
					id: 0,
					name: '一级目录',
					children: []
				};
				menu.children = _this.$handleTree(_this.tableData, "id");
				console.log(menu)
				_this.optionMenus.push(menu);

			},
			handleAdd: function() {
				this.reset();
				this.getTreeselect();
				this.title = "新增菜单";
				this.openDialog = true;
			},
			handleEdit: function(row) {
				this.reset();
				this.title = "修改菜单";
				this.getTreeselect();
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				delete this.form.children;
				this.openDialog = true;
			},
			handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						delPermission(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
								_this.open = false;
								_this.getList();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
			formatStatus: function(row) {
				return row.status == 0 ? '启用' : '禁用';
			},
			formatType: function(row) {
				return row.type == 0 ? '目录' : row.type == 1 ? '菜单' : '按钮';
			}
		}
	};
</script>
<style scoped="scoped">
</style>
